import axios from '@/utils/axios-config';

const getWishlist = async (handshake, mage) => {
  const config = {
    method: 'get',
    url: '/wishlist/',
    headers: {
      Authorization: `Bearer ${handshake}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const addToWishlist = async (handshake, mage, productEntityId) => {
  const config = {
    method: 'put',
    url: `/wishlist/addItem/${productEntityId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: {
      "buyRequest": "1"
    }
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const removeFromWishlist = async (handshake, mage, productEntityId) => {
  const config = {
    method: 'post',
    url: `/wishlist/removeItem/${productEntityId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export { getWishlist, addToWishlist, removeFromWishlist };
